import { useState } from 'react'
import renderImage from '../../../../source/importImg'
import styles from './CustomWards.module.css'
import { Info } from '@material-ui/icons'
import DialogModal from '../../../ReusableComponents/DialogModal/DialogModal'

export const ActionsList = [
    { label: 'Forward', value: 'moveforward' },
    { label: 'Backward', value: 'movebackward' },
    { label: 'Turn Left', value: 'turnleft' },
    { label: 'Turn Right', value: 'turnright' },
    { label: 'Attention', value: 'attention' },
    { label: 'Slide Left', value: 'slideleft' },
    { label: 'Slide Right', value: 'slideright' },
    { label: 'Salute', value: 'salute' },
    { label: 'Dance', value: 'dance' },
    { label: 'Wave', value: 'wave' },
    // { label: 'Fight', value: 'FIGHT' },
    { label: 'Push Up', value: 'pushup' },
    { label: 'Stop', value: 'stop' },
]

const scriptExamples = {
    Hindi: { script: 'Hindi', example: 'आगे बढ़ो' },
    Kannada: { script: 'Kannada', example: 'ಮುಂದೆ ನಡೆ' },
    Telugu: { script: 'Telugu', example: 'ముందుకు వెళ్ళు' },
    Marathi: { script: 'Marathi', example: 'पुढे चला' },
    Malayalam: { script: 'Malayalam', example: 'മുന്നോട്ട് നട' },
    Arabic: { script: 'Arabic', example: 'إلى الأمام' },
    Odia: { script: 'Odia', example: 'ଆଗକୁ ବଢ' },
    English: { script: 'English', example: 'Walk Forward' },
}

function CustomWards(props) {
    const {
        wardsArray,
        setWardsArray,
        isMicActive,
        setIsMicActive,
        duplicateWarning,
        warningPopup,
        setWarningPopup,
        stopListening,
        startListening,
        languageName,
    } = props

    //delete the speech
    const deleteButtonClick = (ind) => {
        let newWardsArray = JSON.parse(JSON.stringify(wardsArray))
        if (ind >= 0 && ind < newWardsArray.length) {
            newWardsArray.splice(ind, 1)
        }
        setWardsArray(newWardsArray)
    }

    const addSpeech = () => {
        setWardsArray([...wardsArray, { text: '', action: '' }])
    }

    const onInputChange = (value, ind) => {
        setWardsArray((prev) =>
            prev.map((item, index) =>
                index === ind ? { ...item, text: value } : item
            )
        )
    }

    const onDropDownChange = (value, ind) => {
        setWardsArray((prev) =>
            prev.map((item, index) =>
                index === ind ? { ...item, action: value } : item
            )
        )
    }

    const handelMicClick = (ind) => {
        if (isMicActive === ind) {
            setIsMicActive(-1)
            stopListening()
        } else {
            setIsMicActive(ind)
            startListening()
        }
    }

    const getCommendsInputValue = (ele, ind) => {
        return ele.text
    }

    return (
        <div className={styles.speechContainer}>
            {/* --------- Duplicate select popUp ---------------*/}
            <DialogModal
                show={warningPopup.isShow}
                text={
                    <div>
                        <p>Warning: {warningPopup.message}</p>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setWarningPopup({ isShow: false, message: '' })
                }
                // optionsToSelect={[
                //     {
                //         text: 'Yes',
                //         do: () => duplicateWarning.onYes(),
                //     },
                //     {
                //         text: 'No',
                //         do: () => duplicateWarning.onNo(),
                //     },
                // ]}
            />
            <DialogModal
                show={duplicateWarning.isShow}
                text={
                    <div>
                        <p>Warning: Duplicate Command</p>
                        <p>{duplicateWarning.message}</p>
                    </div>
                }
                showCloseBtn={false}
                // handleDialogModalClose={() => setIsShowLanguagePopUp(false)}
                optionsToSelect={[
                    {
                        text: 'Yes',
                        do: () => duplicateWarning.onYes(),
                    },
                    {
                        text: 'No',
                        do: () => duplicateWarning.onNo(),
                    },
                ]}
            />

            {languageName && (
                <p style={{ textAlign: 'center', marginBottom: '15px', fontSize: '14px', color: '#666' }}>
                    {scriptExamples[languageName] 
                        ? `Set commands in ${scriptExamples[languageName].script} script (e.g. "${scriptExamples[languageName].example}") only, or select a different language.`
                        : `Set commands in ${languageName} script only, or select a different language.`}
                </p>
            )}

            <div className={styles.wardContainer}>
                {wardsArray?.length > 0 ? (
                    wardsArray.map((ele, ind) => (
                        <div key={ind} className={styles.row}>
                            <p className={styles.rowLabel}>Speech</p>

                            <div className={styles.inputWrapper}>
                                <input
                                    className={styles.rowInput}
                                    type="text"
                                    placeholder="Enter Text"
                                    maxLength={16}
                                    value={getCommendsInputValue(ele, ind)}
                                    onChange={(e) =>
                                        onInputChange(e.target.value, ind)
                                    }
                                />

                                <img
                                    src={
                                        isMicActive === ind
                                            ? renderImage('SpeechAc_Svg')
                                            : renderImage('SpeechIA_Svg')
                                    }
                                    alt="mic"
                                    className={styles.micIcon}
                                    onClick={() => handelMicClick(ind)}
                                />
                            </div>
                            <div
                                className={styles.selectWrapper}
                                onChange={(e) =>
                                    onDropDownChange(e.target.value, ind)
                                }
                            >
                                <select
                                    className={styles.customSelect}
                                    value={ele.action}
                                >
                                    <option value="">Select Action</option>
                                    {ActionsList.map((action) => (
                                        <option
                                            kay={action.value}
                                            value={action.value}
                                        >
                                            {action.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <img
                                style={{ cursor: 'pointer' }}
                                src={renderImage('minusButton')}
                                alt="delete"
                                onClick={(e) => deleteButtonClick(ind)}
                            />
                        </div>
                    ))
                ) : (
                    <div className={styles.emptyActionDiv}>
                        <p> No custom commands add yet.</p>
                        <p> Click the + button to add a command.</p>
                    </div>
                )}
            </div>
            <div className={styles.addBtnDiv}>
                <img
                    src={renderImage('buttonPlusImg')}
                    draggable="false"
                    alt="next"
                    style={{
                        width: '50px',
                        cursor: 'pointer',
                    }}
                    onClick={(e) => addSpeech()}
                />
            </div>
        </div>
    )
}

export default CustomWards
